import { DownloadTypes, FilesExtensions, MediaFilesExtensions, GroupBy } from "src/app/models"


export const DOWNLOAD_TYPES: DownloadTypes[] = [
    {
        type: "all",
        name: "Все типы"
    },
    {
        type: "mediaFiles",
        name: "Медиа файлы"
    },
    {
        type: "textFiles",
        name: "Текстовые файлы"
    }

]
export const FILE_EXTENSIONS: FilesExtensions[] = [
    {
        id: "xls",
        name: "xls"
    },
    {
        id: "xlsx",
        name: "xlsx"
    },
    {
        id: "docx",
        name: "docx"
    },
    {
        id: "csv",
        name: "csv"
    }
]

export const MEDIA_FILE_EXTENSIONS: MediaFilesExtensions[] = [
    {
        id: "png",
        name: "png"
    },
    {
        id: "jpg",
        name: "jpg"
    },
    {
        id: "jpeg",
        name: "jpeg"
    }
]

export const GROUP_BY: GroupBy[] = [
    {
        id: "product",
        name: "Товары"
    },
    {
        id: "attribute",
        name: "Атрибуты"
    }
]